export const AUTHORITY_URL: { [key: string]: string } = {
  prod: "https://accounts.apmterminals.com/root",
  preprod: "https://accounts-stage.apmterminals.com/root-stage",
  test: "https://accounts-cdt.apmterminals.com/root-cdt",
  localhost: "https://accounts-cdt.apmterminals.com/root-cdt"
};

export const ENVIRONMENT_URL: { [key: string]: string } = {
  prod: "https://api.apmterminals.com",
  preprod: "https://api-stage.apmterminals.com",
  test: "https://api-cdt.apmterminals.com",
  localhost: "http://localhost:8080"
};
